import { ConsentStore, type ConsentCategory, type ConsentState } from "./store";
import { mountConsentBanner, type BannerController } from "./banner";

export type { ConsentCategory, ConsentState } from "./store";

export interface RorConsent {
  isGranted(category: ConsentCategory): boolean;
  getState(): ConsentState;
  onGrant(category: ConsentCategory, cb: () => void): () => void;
  openSettings(): void;
}

declare global {
  interface Window {
    rorConsent?: RorConsent;
  }
}

let installed: {
  store: ConsentStore;
  banner: BannerController;
  api: RorConsent;
} | null = null;

export function installConsent(): RorConsent {
  if (installed) return installed.api;

  const store = new ConsentStore();
  const banner = mountConsentBanner(store);

  const api: RorConsent = {
    isGranted: (c) => store.isGranted(c),
    getState: () => store.getState(),
    onGrant: (category, cb) => {
      if (store.isGranted(category)) {
        try {
          cb();
        } catch {
          /* isolate consumer errors from the store */
        }
        return () => {};
      }
      let called = false;
      const unsub = store.subscribe((state) => {
        if (!called && state[category] === true) {
          called = true;
          try {
            cb();
          } catch {
            /* isolate consumer errors */
          }
          unsub();
        }
      });
      return unsub;
    },
    openSettings: () => banner.open("manage"),
  };

  window.rorConsent = api;
  installed = { store, banner, api };
  return api;
}
